import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateServerService {

  constructor() { }
  private delta = null;

  public setDateServer(dateServer: number){
    if(dateServer != null){
      var serverTime = (new Date(dateServer)).getTime();;
      var localTime = (new Date()).getTime();
      this.delta = serverTime -  localTime;
    }
  }

  public  getDateServer(): Date {
    let date = new Date();
    if(this.delta != null){
      date.setTime(date.getTime() + this.delta);
    }
    
    return date;
  }
}
